































import { Component, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { BibliographyRealDetailMarc } from '@/api'
import {
  Col,
  DataTable,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { orderBy } from 'lodash'
import { SortOrder } from '@/types'

const COLS: Col[] = [
  {
    width: '13',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'marcTag',
        headerText: 'タグ',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '13',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'stringLength',
        headerText: 'バイト／文字列',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '74',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'data',
        headerText: '詳細データ',
        sortable: true,
        sortOrder: ''
      }
    ]
  }
]

@Component({
  components: {
    DataTable
  }
})
export default class CollectionMarcTable extends ComponentVue {
  @Prop({
    type: Array,
    default: () => []
  })
  items!: BibliographyRealDetailMarc[]

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get cols(): Col[] {
    return COLS
  }

  get sortedItems(): BibliographyRealDetailMarc[] {
    if (this.sortName) {
      return orderBy<BibliographyRealDetailMarc>(
        this.items,
        this.sortName,
        this.sortOrder as 'asc' | 'desc'[]
      )
    }
    return this.items
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
